import { PROJECT_CATEGORY, PROJECT_TYPE } from './const';
import { getProjectsTypesInCategory } from './projectTypeProps';

export const TEADS_PROJECTS = getProjectsTypesInCategory(PROJECT_CATEGORY.ads).filter((id) =>
  id.includes('teads_')
);

export const PROJECTS_CATEGORIES_VIEWS = {
  documentEditor: 'document_editor',
  blog: 'blog',
};

export function clampProjectCategoryView(input) {
  const values = Object.values(PROJECTS_CATEGORIES_VIEWS);
  if (values.includes(input)) {
    return input;
  }
  return PROJECTS_CATEGORIES_VIEWS.documentEditor;
}

export const PROJECTS_CATEGORIES = [
  {
    id: PROJECT_CATEGORY.ads,
    name: 'Ad',
    projectsTypes: getProjectsTypesInCategory(PROJECT_CATEGORY.ads).filter(
      (id) => !id.includes('teads_')
    ),
    tab: PROJECTS_CATEGORIES_VIEWS.documentEditor,
  },
  {
    id: PROJECT_CATEGORY.blog,
    name: 'Blog',
    projectsTypes: getProjectsTypesInCategory(PROJECT_CATEGORY.blog),
    tab: PROJECTS_CATEGORIES_VIEWS.blog,
  },
  {
    id: PROJECT_CATEGORY.landingPage,
    name: 'Landing page',
    projectsTypes: getProjectsTypesInCategory(PROJECT_CATEGORY.landingPage),
    tab: PROJECTS_CATEGORIES_VIEWS.documentEditor,
  },
  {
    id: PROJECT_CATEGORY.productListing,
    name: 'Product listing',
    projectsTypes: getProjectsTypesInCategory(PROJECT_CATEGORY.productListing),
    tab: PROJECTS_CATEGORIES_VIEWS.documentEditor,
  },
  {
    id: PROJECT_CATEGORY.social,
    name: 'Social',
    projectsTypes: getProjectsTypesInCategory(PROJECT_CATEGORY.social),
    tab: PROJECTS_CATEGORIES_VIEWS.documentEditor,
  },
  {
    id: PROJECT_CATEGORY.productDescription,
    name: 'Product description',
    projectsTypes: getProjectsTypesInCategory(PROJECT_CATEGORY.productDescription),
  },
  {
    id: PROJECT_CATEGORY.email,
    name: 'Email',
    projectsTypes: getProjectsTypesInCategory(PROJECT_CATEGORY.email),
    tab: PROJECTS_CATEGORIES_VIEWS.documentEditor,
  },
  {
    id: PROJECT_CATEGORY.sms,
    name: 'SMS',
    projectsTypes: getProjectsTypesInCategory(PROJECT_CATEGORY.sms),
    tab: PROJECTS_CATEGORIES_VIEWS.documentEditor,
  },
  {
    id: PROJECT_CATEGORY.canvas,
    name: 'Canvas',
    projectsTypes: getProjectsTypesInCategory(PROJECT_CATEGORY.canvas),
    tab: PROJECTS_CATEGORIES_VIEWS.documentEditor,
  },
];

const PROJECTS_CATEGORIES_VIEWS_PROPS = {
  [PROJECTS_CATEGORIES_VIEWS.documentEditor]: {
    title: 'Data-Driven Editor',
    projectType: PROJECT_TYPE.document,
  },
  [PROJECTS_CATEGORIES_VIEWS.blog]: {
    title: 'Blog Wizard',
    projectType: PROJECT_TYPE.blogPostBuilder,
  },
};

export const getProjectCategoryViewFromLocation = (location) => {
  const searchParams = new URLSearchParams(location.search);
  return clampProjectCategoryView(searchParams.get('category'));
};

const getProjectCategoryViewProp = (type, propName, defaultValue = null) => {
  const props = PROJECTS_CATEGORIES_VIEWS_PROPS[type];
  return (props && props[propName]) || defaultValue;
};

export const getProjectCategoryViewTitle = (viewCategory) =>
  getProjectCategoryViewProp(viewCategory, 'title', '');

export const getProjectCategoryViewProjectType = (viewCategory) =>
  getProjectCategoryViewProp(viewCategory, 'projectType');
